module.exports = __webpack_public_path__ + "static/media/ht.f0dfcfc1.svg";